module.exports = __webpack_public_path__ + "fonts/NeuePlakUA-Regular.6e01d27.woff";